import {theme} from 'antd';

const darkTheme = {
    algorithm: theme.darkAlgorithm,
    token: {
        fontSize: 13,
        colorPrimary: '#4A3DFF',
        colorBgContainer: '#1A1B1D',
        colorBgLayout: '#222426',
        colorText: 'rgba(255, 255, 255, 0.85)'
    },
    components: {
        Menu: {
            colorItemBgelected: '#34383f', // 选中项背景
            itemSelectedBg: '#34383F', // 菜单项选中态背景色
            itemSelectedColor: '#D9D9D9',
            darkItemHoverBg: '#282a2f',
            darkItemColor: '#D9D9D9',
            darkItemSelectedBg: '#34383F' // 菜单栏图标背景
        },
        Input: {
            colorBorder: '#32363C',
            colorBgContainer: '#282A2F', // 输入框背景
            activeBorderColor: '#3F444E', // 输入框聚焦边框色
            activeBg: '#282a2f',
            hoverBg: '#282a2f',
            hoverBorderColor: '#3f444e',
            colorBgContainerDisabled: 'rgba(40, 42, 47, 0.5)',
            borderRadius: '6px',
            activeShadow: '#32363C'
        },
        Button: {
            iconGap: '6px',
            colorPrimaryHover: '#5D54FF', // 按钮悬停色
            colorInfoActive: '#3E2CE6', // 按钮激活色
            contentFontSizeSM: '12px',
            paddingBlockSM: '4px',
            paddingInlineSM: '10px',
            borderRadius: '6px',
            borderRadiusSM: '6px',
            borderRadiusLG: '6px',
            borderColorDisabled: '#32363C',
            defaultActiveBg: '#222426',
            defaultHoverBg: '#34383F',
            defaultActiveBorderColor: '#32363C',
            defaultBg: '#282A2F',
            defaultColor: '#fff',
            defaultBorderColor: '#32363C',
            defaultActiveColor: '#fff',
            defaultGhostColor: '#fff',
            defaultHoverColor: '#fff',
            defaultHoverBorderColor: '#3F444E',
            defaultShadow: 'none',
            defaultActiveShadow: 'none',
            textHoverBg: '#1A1B1D',
            textTextHoverColo: '#fff',
            paddingBlock: '6px',
            paddingInline: '24px',
            contentFontSize: '13px',
            colorError: '#FA423C',
            colorErrorActive: '#D42828',
            dangerColor: '#fff',
            colorErrorHover: '#FF6C64',
            colorErrorActiveHover: '#D42828',
            linkHoverBg: '#1A1B1D',
            textTextColor: '#B3B3B3',
            primaryShadow: 'none',
            colorPrimary: '#4A3DFF',
            colorPrimaryBg: '#4A3DFF',
            colorPrimaryBgHover: '#5C6CFF',
            colorPrimaryTextActive: '#3714E6',
            colorPrimaryBorder: 'rgba(3, 3, 27, 0.07)',
            dangerShadow: 'none' // 危险按钮阴影
        },
        Card: {
            colorBgContainer: '#252526', // 卡片背景
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.5)',
            borderRadiusLG: '20px'
        },
        Table: {
            cellFontSize: '13px',
            bodySortBg: '#222426',
            borderColor: '#2B2D31',
            filterDropdownBg: '#282A2F',
            headerBg: '#222426',
            headerColor: '#B3B3B3',
            headerFilterHoverBg: '#EBEBEB',
            headerSplitColor: '#222426',
            colorBgContainer: '#1e1e1e',
            rowHoverBg: '#282A2F',
            rowSelectedHoverBg: '#282A2F',
            cellPaddingInline: '12px',
            cellPaddingBlock: '10px',
            headerBorderRadius: '6px'
        },
        Layout: {
            headerBg: '#191b1e' // 直接控制 Layout 组件的 Header 背景
        },
        Tooltip: {
            colorBgSpotlight: '#000', // 提示框背景
            colorText: '#fff'
        },
        Modal: {
            contentBg: '#1a1b1d',
            borderRadiusLG: '12px'
        },
        Popover: {
            colorBgElevated: '#000',
            colorBgContainer: '#000',
            borderRadiusLG: '6px'
        },
        Select: {
            optionSelectedBg: '#3F444E', // 选项选中时背景色
            optionActiveBg: '#34383F', // 选项激活态时背景色
            hoverBorderColor: '#33383F',
            activeOutlineColor: '#3F444E',
            optionSelectedColor: '#FAFAFA',
            activeBorderColor: '#32363C',
            optionHeight: '32px',
            optionFontSize: '13px'
        },
        Slider: {
            dotActiveBorderColor: '#4A3DFF',
            dotBorderColor: '#4A3DFF',
            trackBg: '#4A3DFF',
            trackHoverBg: '#4A3DFF',
            railBg: '#34383f',
            railHoverBg: 'none'
        },
        Tabs: {
            cardBg: '#222426',
            itemActiveColor: '#FAFAFA',
            itemColor: '#666666',
            itemSelectedColor: '#FAFAFA',
            itemHoverColor: '#666666',
            inkBarColor: '#4A3DFF',
            colorBorder: '#32363C'
        },
        Progress: {
            defaultColor: '#4A3DFF',
            colorSuccess: '#13B982',
            marginXS: '4px'
        },
        Tree: {
            titleHeight: 20
        },
        Message: {
            contentBg: '#282a2f',
            boxShadow: 'rgba(0, 25, 126, 0.08)',
            contentPadding: '14px 16px'
        },
        Radio: {
            buttonCheckedBg: '#4A3DFF',
            buttonSolidCheckedActiveBg: '#4A3DFF',
            colorPrimaryBorder: 'none'
        },
        InputNumber: {
            handleBg: '#282A2F',
            activeBorderColor: '#282A2F',
            handleHoverColor: '#FAFAFA',
            hoverBorderColor: '#32363C'
        },
        Switch: {
            colorPrimary: '#4A3DFF',
            colorTextQuaternary: '#3F444E'
        },
        Segmented: {
            itemHoverBg: 'none',
            itemHoverColor: '#EBEBEB'
        },
        Divider: {
            lineWidth: '0.5px'
        },
        Step: {
            colorPrimary: '#4a3dff',
            colorPrimaryBg: '#b2b5ff',
            colorPrimaryBgHover: '#5D54FF'
        }
    }
};

export default darkTheme;
